// extracted by mini-css-extract-plugin
export default {"button":"LinkButton_button__nyPuA","primaryColor":"LinkButton_primaryColor__7nPJO","secondaryColor":"LinkButton_secondaryColor__kAo8k"};